// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import {IPostCategories, IFetchPost, IFetchPosts} from 'app_types/campus/postTypes'
// @end

class PostService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  fetchPost = async (slug: string) => {
    let responseData: IFetchPost

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/data/post/fetch-post/${slug}`,
      auth_token: this.token,
      params: {},
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchPosts = async (params: any = {}) => {
    let responseData: IFetchPosts

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/post/fetch-posts`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  fetchCategories = async () => {
    let responseData: IPostCategories

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/post/fetch-categories`,
      auth_token: this.token,
      params: {},
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }


}

export default PostService
